import Http from "./http";

export default {
  getAll: async student_id => {
    let data = await Http.get(`/students/${student_id}/achievements`);
    return data.data;
  }
};
